var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"multiselect__tag",style:({ 'background-color': _vm.color, 'border-color': _vm.borderColor, color: _vm.textColor })},[_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }